import { createContext, useContext } from "react";

/**
 * Provides the report content container element to descendants rendered deep
 * inside markdown (e.g. the collapsed citation dropdown). Popovers portal into
 * this element so their content stays within the click-delegation root
 * (`useSourceMapDelegation`) while avoiding invalid block-in-`<p>` nesting.
 */
export const ReportContainerContext = createContext<HTMLElement | null>(null);

export const useReportContainer = (): HTMLElement | null =>
  useContext(ReportContainerContext);
